import React from 'react';
import { Link } from 'react-router-dom';

export default function App() {
  return (
    <div className='bg-neutral-800'>
      <footer className="text-center text-neutral-600 dark:text-neutral-200 lg:text-left">
        <div className="flex flex-col items-center justify-center lg:flex-row border-b-2 border-neutral-200 p-6 dark:border-neutral-500 lg:justify-between">
          <div className="mr-12 sm:mx-8 mx-10 open lg:block">
            <p className='font-bold'>Talk to us, we'd love to hear from you!</p>
          </div>
          {/* Social network icons container */}
          <div className="flex justify-center items-center space-x-6 lg:space-x-12 mt-6 lg:mt-0">
            {/* Twitter link */}
            <a href="https://x.com/amani_balozi?t=MpJmNbAVgPkfc12hy0gTXA&s=08" target="_blank" className="mx-4 md:mx-6 transition-transform transform hover:scale-110" style={{textDecoration: 'none'}}>
              <img width="32" height="32" src="https://img.icons8.com/ios-filled/50/twitterx--v1.png" alt="twitterx--v1" style={{ filter: "invert(1)" }} />
            </a>

            {/* Facebook link */}
            <a href="https://www.facebook.com/share/ViGBjUs7Qxdf1zoE/?mibextid=qi2Omg" target="_blank" className="mx-4 md:mx-6 py-0.5 transition-transform transform hover:scale-110" style={{textDecoration: 'none'}}>
              <img width="27" height="27" src="https://img.icons8.com/android/24/facebook.png" alt="facebook" style={{ filter: "invert(1)" }} />
            </a>

            {/* Instagram link */}
            <a href="https://www.instagram.com/balozi_wa_amani_initiative?igsh=bnN0eTBmeTJzM3l5" target="_blank" className="mx-4 md:mx-6 py-0.5 transition-transform transform hover:scale-110" style={{textDecoration: 'none'}}>
              <img width="28" height="28" src="https://img.icons8.com/ios/50/instagram-new--v1.png" alt="instagram-new--v1" style={{ filter: "invert(1)" }} />
            </a>
          </div>
        </div>

        {/* Main container div */}
        <div className="flex flex-row justify-center items-center px-6 py-10 text-center ">
          <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
            {/* TW Elements section */}
            <div className="">
              <h5 className="mb-4 text-red-600 flex items-center justify-center font-semibold font-heading2 uppercase md:justify-start">
                <img width="120" height="120" className="sm:mx-2 mx-2.5 h-8 w-auto" src="images/logo1.png" alt="Your Company" />
                Balozi Wa Amani
              </h5>
              <p className='pb-6 font-bold'>
                Giving is not just about making a donation. It's about making a difference.
              </p>
              
            </div>

            {/* Useful links section */}
            <div className="mx-6">
              <h6 className="mb-4 text-2xl text-red-600 flex justify-center font-bold uppercase md:justify-start">
                Navigation Links
              </h6>
              <p className="mb-4 mx-10  flex items-center justify-center md:justify-start transition-transform transform hover:scale-105">
                <Link to="/" className=" hover:text-white font-bold text-neutral-600 dark:text-neutral-200" style={{textDecoration: 'none'}}>
                  Home
                </Link>
              </p>
              {/* Other navigation links */}
              <p className="mb-4 mx-10 flex items-center justify-center md:justify-start transition-transform transform hover:scale-105">
                <Link to="/about" className="hover:text-white font-bold text-neutral-600 dark:text-neutral-200" style={{textDecoration: 'none'}}>
                  About
                </Link>
              </p>
              <p className="mb-4 mx-10  flex items-center justify-center md:justify-start transition-transform transform hover:scale-105">
                <Link to="/gallery" className="hover:text-white font-bold text-neutral-600 dark:text-neutral-200" style={{textDecoration: 'none'}}>
                  Gallery
                </Link>
              </p>
              <p className="mb-4 mx-10  flex items-center justify-center md:justify-start transition-transform transform hover:scale-105">
                <Link to="/events" className="hover:text-white font-bold text-neutral-600 dark:text-neutral-200" style={{textDecoration: 'none'}}>
                  Events
                </Link>
              </p>
              <p className="mb-4 mx-10  flex items-center justify-center md:justify-start transition-transform transform hover:scale-105">
                <Link to="/Donate" className=" hover:text-white  font-bold text-neutral-600 dark:text-neutral-200" style={{textDecoration: 'none'}}>
                  Take Action
                </Link>
              </p>
              <p className="mb-4 mx-10  flex items-center justify-center md:justify-start transition-transform transform hover:scale-105">
                <Link to="/contact" className=" hover:text-white font-bold text-neutral-600 dark:text-neutral-200" style={{textDecoration: 'none'}}>
                  Contacts
                </Link>
              </p>
            </div>

        <div className="">
          <div className='flex justify-center items-center'>
            <h6
              className="mb-4 text-2xl text-red-600 flex justify-center font-bold uppercase md:justify-start">
              Contact
            </h6>
        </div>
            <div className='pb-2 flex items-center justify-center'>
            <a href="mailto:baloziwaamaniinitiative@gmail.com" className="text-red-600">    
               <button className='px-16 bg-red-600 rounded-md py-2 text-black font-bold transition-transform transform hover:scale-110'>Email</button>
               {/* <h6 className='py-2 text-neutral-900 dark:text-neutral-600'> baloziwaamaniinitiative@gmail.com</h6> */}
             </a>
              </div>
            
          </div>

          
        <div className="hidden lg:block">
          <div className='flex justify-center items-center'>
            <h6
              className="mb-4 text-2xl text-red-600 flex justify-center font-bold uppercase md:justify-start">
              Others
            </h6>
        </div>
            <p className=" font-bold mb-4 mx-4 flex items-center justify-center md:justify-start">
             Terms And Conditions Apply.
            </p>    
          </div>

          </div>  
      </div>
      

        {/* Copyright section */}
        <div className="dark:bg-neutral-900 p-6 text-center ">
          <span>Copyright : © 2026 Balozi Wa Amani</span>
        </div>
        <div className='pb-2 dark:bg-neutral-900'>
          <a href="https://ernestmaina.vercel.app" className="mx-2 text-neutral-900 dark:text-neutral-600" target="_blank">
            Website by Ernest Maina.
          </a>
        </div>
      </footer>
    </div>
  );
}
